(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/map-of-winners/assets/javascripts/views/map.js') >= 0) return;  svs.modules.push('/modules/map-of-winners/assets/javascripts/views/map.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.map_of_winners.views.map = Marionette.View.extend({
    CONSTANTS: svs.map_of_winners.data.constants,
    template(data) {
      return svs.map_of_winners.templates.map(data);
    },
    id: 'mowMap',
    pins: [],
    clusterPins: [],
    zoomed: false,
    className: 'mow-container',
    zoomScale: 1,
    zoomValue: 0,
    currentVP: {
      x: 0,
      y: 0
    },
    markedCluster: undefined,
    deviceSize: 2,
    isDeviceScaled: false,
    aspectRatio: 0,
    mapHeightScale: 0,
    ui: {
      $mapContent: '#mapContent',
      $mowMap: '#mowMap',
      $zoomable: '#zoomable' 
    },
    initialize(options) {
      this.aspectRatio = options.aspectRatio;
      this.mapHeightScale = options.mapHeightScale;
      if (svs.core.detect.formfactor.mobile()) {
        this.deviceSize = 1.5; 
        this.isDeviceScaled = true; 
      } else {
        window.addEventListener('resize', () => {
          const mapHeight = window.innerHeight * this.mapHeightScale,
            mapWidth = mapHeight / this.aspectRatio;
          $('#mapContent').css({
            width: "".concat(mapWidth, "px")
          });
          $('#svgMap').css({
            width: "".concat(mapWidth, "px"),
            height: "".concat(mapHeight, "px")
          });
        });
      }
      this.handleBubbleClickOutsideEvent = this.handleBubbleClickOutsideEvent.bind(this);
    },
    fitMap() {
      const winType = this.CONSTANTS.WIN_TYPE.ANDRA_CHANSEN;
      const sortedCollection = this.collection.filterByAttributes({
        winType
      }).sortMapCluster(svs.core.detect.formfactor.mobile());
      for (let i = 0; i < sortedCollection.length; i++) {
        if (sortedCollection.at(i).get('clustered')) {
          const cluster = sortedCollection.at(i).get('cluster');
          cluster.splitCluster = true;
          cluster.size = 0;
          for (let j = 0; j < cluster.length; j++) {
            if (cluster[j].get('onlineCluster')) {
              const onlineCluster = cluster[j].get('cluster');
              cluster.size += onlineCluster.length;
              onlineCluster.onlineCluster = true;
              onlineCluster.clustered = true;
              onlineCluster.size = onlineCluster.length;
              this.createClusterMarker(onlineCluster);
            } else {
              cluster.size++;
              this.createMarker(cluster[j]);
            }
          }
          this.createClusterMarker(cluster);
        } else if (sortedCollection.at(i).get('onlineCluster')) {
          const cluster = sortedCollection.at(i).get('cluster');
          cluster.onlineCluster = true;
          cluster.size = cluster.length;
          this.createClusterMarker(cluster);
        } else {
          this.createMarker(sortedCollection.at(i));
        }
      }
      this.drawMap();
    },
    createMarker(winning) {
      const marker = $('<div class="marker"><span class="marker-content"></span></div>');
      if (!winning.get('clustered')) {
        marker.addClass('single-marker');
      }
      marker.x = winning.get('position').horizontalPos;
      marker.y = winning.get('position').verticalPos;
      delete winning.position;
      marker.winning = winning;
      marker.css({
        top: "".concat(marker.y, "%"),
        left: "".concat(marker.x, "%")
      });
      marker.on('click', () => {
        this.markerClick(marker);
      });
      this.pins.push(marker);
    },
    createClusterMarker(cluster) {
      let clusterMarker = $("<div class=\"cluster-marker\"><div class=\"marker-content\"><label style=\"z-index:-1\" class=\"marker-size\">".concat(cluster.size, "<label></div></div>")),
        scaleSize = cluster.length / 10 + 1;
      const x = cluster[0].get('position').horizontalPos,
        y = cluster[0].get('position').verticalPos;
      if (cluster.clustered) {
        clusterMarker = $("<div class=\"marker cluster-marker animation-hide\"><div class=\"marker-content\"><label style=\"z-index:-1\" class=\"marker-size\">".concat(cluster.size, "<label></div></div>"));
      }
      scaleSize = Math.min(Math.max(scaleSize, 1), 1.5);
      clusterMarker.x = x;
      clusterMarker.y = y;
      clusterMarker.onlineCluster = cluster.onlineCluster;
      clusterMarker.splitCluster = cluster.splitCluster;
      if (cluster.onlineCluster) {
        const groupedCluster = this.collection.mergeByKeyValue(['winType', 'retailer', 'city', 'gameType', 'shares'], cluster, true);
        clusterMarker.groupedCluster = groupedCluster.models;
        if (!cluster.clustered) {
          clusterMarker.addClass('single-marker');
        }
      }
      clusterMarker.scaleSize = scaleSize;
      clusterMarker.css({
        top: "".concat(y, "%"),
        left: "".concat(x, "%")
      });
      clusterMarker.css('transform', "scale(".concat(scaleSize, ") translate(-").concat(10 / scaleSize, "px,-").concat(10 / scaleSize, "px)")); 
      clusterMarker.on('click', () => {
        this.markerClick(clusterMarker);
      });
      if (!cluster.clustered) {
        this.clusterPins.push(clusterMarker);
      } else {
        this.pins.push(clusterMarker);
      }
    },
    resetMarkerSize() {
      if (this.markedCluster) {
        this.markedCluster.css('transform', "scale(".concat(this.markedCluster.scaleSize, ") translate(-").concat(10 / this.markedCluster.scaleSize, "px,-").concat(10 / this.markedCluster.scaleSize, "px)"));
        this.markedCluster = undefined;
      }
    },
    minimizeMarker(clusterMarker) {
      clusterMarker.css({
        transform: 'scale(1) translate(-10px, -10px)'
      });
    },
    onDomRefresh() {
      const mapHeight = window.innerHeight * this.mapHeightScale,
        mapWidth = mapHeight / this.aspectRatio;
      $('#mapContent').css({
        width: "".concat(mapWidth, "px")
      });
      $('#svgMap').css({
        width: "".concat(mapWidth, "px"),
        height: "".concat(mapHeight, "px")
      });
      this.fitMap();
      this.reDrawMap();
    },
    drawMap() {
      for (const x in this.pins) {
        this.getUI('$zoomable').append(this.pins[x]);
      }
      for (const x in this.clusterPins) {
        this.getUI('$zoomable').append(this.clusterPins[x]);
      }
    },
    addBubbleClickOutsideEvent() {
      document.getElementById('mowMap').addEventListener('click', this.handleBubbleClickOutsideEvent);
    },
    removeBubbleClickOutsideEvent() {
      document.getElementById('mowMap').removeEventListener('click', this.handleBubbleClickOutsideEvent);
    },
    handleBubbleClickOutsideEvent() {
      const isBubbleVisible = $('.bubble').length && $('.bubble').css('opacity') === '1';
      if (isBubbleVisible) {
        this.resetMap();
      }
    },
    markerClick(marker) {
      const self = this;
      this.addBubbleClickOutsideEvent();
      $('.bubble').remove();
      self.resetMarkerSize(marker);
      $('.marked-pin').removeClass('marked-pin');
      if (self.deviceSize > 1.5) {
        self.mapZoom(self.deviceSize);
      } else {
        self.mapZoom(self.deviceSize - 0.3);
      }
      if ($(marker).hasClass('cluster-marker')) {
        self.minimizeMarker(marker);
      }
      self.markedCluster = marker;
      if (!marker.splitCluster) {
        $(marker).addClass('marked-pin');
        if (marker.groupedCluster) {
          $(marker).prepend(svs.map_of_winners.templates.infobubble(marker.groupedCluster)); 
        } else {
          $(marker).prepend(svs.map_of_winners.templates.infobubble([marker.winning])); 
        }
        $('.bubble-container').on('mouseup mousedown click mousewheel', e => {
          e.stopPropagation();
        });
        $('#close-bubble').on('click', e => {
          e.stopPropagation();
          self.resetMap();
        });
        if (marker.y > 50) {
          $('.map-info-bubble').addClass('map-info-bubble-up');
        } else {
          $('.map-info-bubble').addClass('map-info-bubble-down');
        }
        if (marker.groupedCluster && marker.groupedCluster.length >= 3) {
          $('.map-info-bubble').addClass('scroll-bubble');
        }
        const x = 60 - marker.x;
        let y = 50 - marker.y;
        const baseMultiplier = self.isDeviceScaled ? -5 : 5,
          panMultiplier = baseMultiplier * Math.min(Math.max(marker.groupedCluster && marker.groupedCluster.length, 1), 2);
        if (marker.y < 50) {
          y += panMultiplier || baseMultiplier;
        } else {
          y -= panMultiplier || baseMultiplier;
        }
        self.panViewPort(x, y, true);
      } else {
        const x = 50 - marker.x,
          y = 50 - marker.y;
        self.panViewPort(x, y);
      }
    },
    reDrawMap() {
      const hide = 'animation-hide';
      if (this.zoomScale >= this.deviceSize) {
        for (let i = 0; i < this.pins.length; i++) {
          this.pins[i].removeClass(hide);
        }
        for (let i = 0; i < this.clusterPins.length; i++) {
          this.clusterPins[i].addClass(hide);
        }
      } else if (this.zoomScale <= this.deviceSize) {
        for (let i = 0; i < this.pins.length; i++) {
          this.pins[i].addClass(hide);
        }
        for (let i = 0; i < this.clusterPins.length; i++) {
          this.clusterPins[i].removeClass(hide);
        }
      }
    },
    mapZoom(scale) {
      let newScale = 1;
      if (scale) {
        this.zoomScale = scale;
        newScale = scale;
      } else {
        this.zoomScale += this.zoomValue;
        newScale = this.zoomScale;
      }
      this.getUI('$zoomable').css('transform', "scale(".concat(newScale, ")"));
      this.reDrawMap();
      this.zoomed = true;
    },
    mapZoomnOut() {
      if (this.zoomed) {
        $('.marked-pin').removeClass('marked-pin');
        this.getUI('$zoomable').css('transform', 'scale(1)');
        this.zoomed = false;
      }
      this.getUI('$mapContent').css({
        transform: 'translate(0px, 0px)'
      }); 
      this.reDrawMap();
    },
    panViewPort(x, y, hardPan) {
      const self = this;
      x = x || this.currentVP.x;
      y = y || this.currentVP.y;
      if (Math.abs(x) < 70 + self.zoomScale * 20 || hardPan || Math.abs(x) < Math.abs(this.currentVP.x)) {
        this.currentVP.x = x;
      }
      if (Math.abs(y) < 70 + self.zoomScale * 20 || hardPan || Math.abs(y) < Math.abs(this.currentVP.y)) {
        this.currentVP.y = y;
      }
      self.getUI('$mapContent').css({
        transform: "translate(".concat(self.currentVP.x, "%, ").concat(self.currentVP.y, "%)")
      });
    },
    panOutViewPort() {
      const numOfZoomsleft = (this.zoomScale - 1) / Math.abs(this.zoomValue),
        panvalueX = this.currentVP.x / numOfZoomsleft,
        panvalueY = this.currentVP.y / numOfZoomsleft;
      this.panViewPort(this.currentVP.x - panvalueX, this.currentVP.y - panvalueY);
    },
    resetMap(event) {
      const self = event && event.data || this;
      self.currentVP = {
        x: 0,
        y: 0
      };
      self.zoomScale = 1;
      self.resetMarkerSize($('.cluster-marker'));
      $('.bubble').remove();
      self.mapZoomnOut();
      self.removeBubbleClickOutsideEvent();
    }
  });
})(Backbone, _, svs);

 })(window);